import React, { Component } from 'react'
import Axios from 'axios'
import { toast, ToastContainer } from 'react-toastify'
import Loader from '../Loader'
import ProgressBar from '../ProgressBar/ProgressBar'
import { Urls } from '../../Urls'
import { constants } from '../../constants'
import { logActivity } from '../Utilities'
var raw_suggestion = []
var raw_manual = []
var raw_input = []
var current_row = 0
class MultipleLocation extends Component {
    constructor(props) {
        super(props)

        this.state = {
            fetched_data: [],
            search_list: [],
            loader: false,
            locAuto: []
        }
    }

    componentDidMount() {
        // logActivity([
        //     {
        //         'screen': 'Multiple Location Cleaning',
        //         'module': 'Location Cleaning',
        //         'user_activity': 'page viewed',
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        document.title = "DC | Multiple Location"
        var body = {
            "dataset_id": localStorage.getItem("dataset_id"),
            "key": "multi"
        }
        document.getElementById("header").style.opacity = "0.5"
        this.setState({
            loader: true
        }, () => {
            Axios.post(Urls.location.fetch, body)
                .then(res => {
                    console.log(res.data)
                    this.setState({
                        fetched_data: res.data.data,
                        search_list: res.data.search,
                        loader: false
                    }, () => { if (this.state.fetched_data.length === 0) { this.props.history.push({ pathname: "/spellCorrectionLocation" }) } })
                    document.getElementById("header").style.opacity = "1"
                    var i;
                    for (i = 0; i < this.state.fetched_data.length; i++) {
                        raw_suggestion.push({ 'suggestion': this.state.fetched_data[i].Suggestion[0] })
                        raw_manual.push({ "manual": "" })
                    }
                })
                .catch(err => {
                    this.setState({ loader: false })
                    document.getElementById("header").style.opacity = "1"
                    console.log(err.response)
                    toast.error("Error while processing your reuest")
                })
        })

    }

    selectChangeHandler = (event) => {
        if (event.target.value === "Other") {
            document.getElementById(event.target.name).disabled = false
            document.getElementById(event.target.name).style.border = "1px solid royalblue"
            raw_suggestion[event.target.name] = { "suggestion": "Other" }
        }
        else if (event.target.value === 'same_as_client_data') {
            document.getElementById(event.target.name).disabled = false
            var client_data = `${this.state.fetched_data[event.target.name]['Raw Location']},,${this.state.fetched_data[event.target.name]['Raw State']}`
            document.getElementById(event.target.name).value = client_data
            raw_suggestion[event.target.name] = { "suggestion": "Other" }
            raw_manual[event.target.name] = { "manual": client_data }
        }
        else {
            document.getElementById(event.target.name).disabled = true
            document.getElementById(event.target.name).style.border = "none"
            raw_manual[event.target.name] = { "manual": "" }
            raw_suggestion[event.target.name] = { "suggestion": event.target.value }
        }
    }

    goToUniueLocation = (e) => {
        this.props.history.push({
            pathname: '/uniqueLocation'
        })
    }

    manualHandler = (event) => {
        current_row = parseInt(event.target.id)
        if (event.target.value !== "" && ((event.target.value.length >= 3))) {
            Axios.get(`${Urls.autocomplete}?country=INDIA&limit=10&suggest=${event.target.value}&searchFields=locations`)
                .then(res => {
                    this.setState({
                        locAuto: res.data.value
                    })
                })
                .catch(error => {
                    console.log(error)
                })
        }


        raw_manual[event.target.id] = { "manual": event.target.value }
    }

    submitHandler = (event) => {
        var emptyRows = []
        event.preventDefault()
        var patternStatus = true
        var i = 0
        for (i = 0; i < raw_manual.length; i++) {
        console.log(i)
            if (document.getElementById(i) && document.getElementById(i).disabled && document.getElementById(i).disabled === false) {
                if (!new RegExp(constants.regex_patterns.emptyString).test(raw_manual[i]['manual'])) {
                    if (!new RegExp(constants.regex_patterns.location).test(raw_manual[i]['manual'])) {
                        document.getElementById(i).style.border = '1px solid red'
                        emptyRows.push(raw_manual[i]['manual'])
                        console.log(raw_manual[i]['manual'])
                    }
                    else {
                        document.getElementById(i).style.border = 'none'
                        patternStatus = true
                    }
                }
            }
        }

        if (emptyRows.length === 0) {
            // logActivity([
            //     {
            //         'screen': 'Multiple Location Cleaning',
            //         'module': 'Location Cleaning',
            //         'user_activity': 'data submission',
            //         'timestamp': new Date().toISOString()
            //     }
            // ])
            raw_input = []
            event.preventDefault()
            raw_input.push(raw_suggestion)
            raw_input.push(raw_manual)
            var body = {
                "dataset_id": localStorage.getItem("dataset_id"),
                "key": "multi",
                "input": raw_input
            }
            console.log(raw_input)
            document.getElementById("header").style.opacity = "0.5"
            this.setState({
                loader: true
            }, () => {
                Axios.post(Urls.location.dump, body)
                    .then(res => {
                        console.log(res)
                        document.getElementById("header").style.opacity = "1"
                        sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
                        this.props.history.push({ pathname: '/spellCorrectionLocation' })
                    })
                    .catch(err => {
                        console.log(err)
                    })
            })
        }
        else {
            alert('Please enter correct location, Eg. City, District(optional), State')
        }
    }

    // navigations toggles
    goBack = () => {
        this.props.history.push({
            pathname: "/uniqueLocation"
        })
    }

    render() {
        var locations = this.state.fetched_data
        var searchItems = this.state.locAuto
        var c_row = current_row
        return (
            <div id="header">
                <ToastContainer />
                <Loader isLoading={this.state.loader} />
                <div className="container">
                    <div style={{ "margin-bottom": "5%" }} >
                        <div align="center" className="row">
                            <div className="col-1">
                                <button onClick={this.goBack}><i className="navButtonsCircleLeft fas fa-arrow-circle-left"></i></button>
                            </div>
                            <div className="col-10">
                                <table border="1" id="dc_table">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>
                                                Raw Location
                                    </th>
                                            <th>
                                                Raw State
                                    </th>
                                            <th>
                                                Suggestion
                                    </th>
                                            <th>
                                                User Input
                                    </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            locations.map((location, i) =>
                                                
                                                (location.Suggestion.length === 0) ? (
                                                    <tr style={{ "backgroundColor": "#EEEEEE" }}>
                                                        {console.log(i)}
                                                        <td> {i + 1} </td>
                                                        <td> {location['Raw Location']} </td>
                                                        <td> {location['Raw State']} </td>
                                                        <td>
                                                            <select name={i} onChange={this.selectChangeHandler}>
                                                                {
                                                                    location.Suggestion.map(s => <option value={s}> {s} </option>)
                                                                }
                                                                <option style={{ backgroundColor: 'yellow', color: 'red' }} value="same_as _client_data">Same as Client Data</option>
                                                                <option value="Other">Other</option>
                                                            </select>
                                                        </td>
                                                        <td>
                                                            <input className="form-control" list="auto" placeholder="City, District, State" type="text" id={i} onChange={this.manualHandler} disabled />
                                                            {
                                                                (c_row === i) ? (
                                                                    <datalist id="auto">
                                                                        {
                                                                            (searchItems.length === 0 || searchItems === undefined) ? (<option>No location found!</option>) : (
                                                                                searchItems.map(item => <option value={`${item.location.location}, ${item.location.district}, ${item.location.state}, ${item.location.lat}, ${item.location.lon}`}> {`${item.location.location}, ${item.location.district}, ${item.location.state}`} </option>
                                                                                ))
                                                                        }
                                                                    </datalist>
                                                                ) : (null)
                                                            }
                                                        </td>
                                                    </tr>
                                                ) : (
                                                        <tr>
                                                            <td> {i + 1} </td>
                                                            <td> {location['Raw Location']} </td>
                                                            <td> {location['Raw State']} </td>
                                                            <td>
                                                                <select name={i} onChange={this.selectChangeHandler}>
                                                                    {
                                                                        location.Suggestion.map(s => <option value={s}> {s} </option>)
                                                                    }
                                                                    <option value="same_as_client_data">Same as Client Data</option>
                                                                    <option value="Other">Other</option>
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <input className="form-control" list="auto" placeholder="City, District, State" type="text" id={i} onChange={this.manualHandler} disabled />
                                                                {
                                                                    (current_row === i) ? (
                                                                        <datalist id="auto">
                                                                            {
                                                                                (searchItems.length === 0 || searchItems === undefined) ? (<option>No location found!</option>) : (
                                                                                    searchItems.map(item => <option value={`${item.location.location}, ${item.location.district}, ${item.location.state}, ${item.location.lat}, ${item.location.lon}`}> {`${item.location.location}, ${item.location.district}, ${item.location.state}`} </option>
                                                                                    ))
                                                                            }
                                                                        </datalist>
                                                                    ) : (null)
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-1 navButtonsCircleRight">
                                <button onClick={this.submitHandler} title="Submit" ><i className=" fas fa-arrow-circle-right"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer_div">
                    <ProgressBar progress="46%" />
                </div>
            </div>
        )
    }
}

export default MultipleLocation
